var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.record[_vm.facet.key])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }